import { Video } from 'lucide-react';
import { useObjectUrl, fmtDur } from '../lib/media';

export default function MediaThumb({ item, className = 'photo-thumb', testid }) {
  const url = useObjectUrl(item.kind === 'video' ? item.blob : null);
  if (item.kind === 'video') {
    return (
      <div className="video-thumb" data-testid={testid}>
        <video className={className} src={url || undefined} poster={item.thumb || undefined} controls playsInline preload="metadata" />
        <span className="video-tag"><Video size={10} /> {fmtDur(item.duration)}</span>
      </div>
    );
  }
  return <img className={className} src={item.data} alt="" data-testid={testid} />;
}
